<template>
    <div>
        <div class="py-5">
            <h2>Email Management</h2>
        </div>

        <form class="needs-validation" novalidate v-on:submit.prevent="update()">
            <h3></h3>
            <div class="container-fluid">
                <div class="form-group row p-2" v-bind:class="{'bg-danger': !admin_porting_emails, 'text-light': !admin_porting_emails}">
                    <label for="admin_porting_emails" class="col-sm-2 col-form-label">Admin Emails</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="admin_porting_emails" v-model="admin_porting_emails" v-bind:class="{'bg-danger': !admin_porting_emails}">
                        <ol class="my-3 pl-4" v-bind:class="{'text-light': !admin_porting_emails, 'text-muted': admin_porting_emails}">
                            <li>
                                <small class="form-text">Emails must be the emails of admin user from [<a href="/site-management/show-user-navbar/list-users">Site management &gt; list users</a>]</small>
                            </li>
                            <li>
                                <small class="form-text">Admin user only</small>
                            </li>
                            <li>
                                <small class="form-text">User account must be verified</small>
                            </li>
                            <li>
                                <small class="form-text">User account must not be suspended</small>
                            </li>
                            <li>
                                <small class="form-text">Multiple emails can be separated by [;], such as: aaa@emiot.com.au;bbb@emiot.com.au;ccc@emiot.com.au</small>
                            </li>
                        </ol>
                    </div>
                </div>

                <div class="form-group row p-2" v-bind:class="{'bg-danger': send_test_failed_email_block_threshold === '0', 'text-light': send_test_failed_email_block_threshold === '0'}">
                    <label for="send_test_failed_email_block_threshold" class="col-sm-2 col-form-label">Failed devices threshold = {{send_test_failed_email_block_threshold}}</label>
                    <div class="col-sm-10">
                        <input type="range"
                               min="0" max="999" step="1"
                               class="form-control"
                               id="send_test_failed_email_block_threshold"
                               aria-describedby="send_test_failed_email_block_threshold_help"
                               v-model="send_test_failed_email_block_threshold"
                               v-bind:class="{'bg-danger': !send_test_failed_email_block_threshold}">
                        <small id="send_test_failed_email_block_threshold_help"
                               class="form-text"
                               v-bind:class="{'text-light': send_test_failed_email_block_threshold === '0', 'text-muted': send_test_failed_email_block_threshold !== '0'}"
                        >The threshold number of devices triggers send to admin emails only. Once failed devices greater than {{send_test_failed_email_block_threshold}} failed emails would no longer send to users.</small>
                    </div>
                </div>
            </div>

            <div class="form-group" v-bind:class="{'bg-danger': !send_building_test_notification_email, 'text-light': !send_building_test_notification_email}">
                <div class="form-check form-check-inline p-2">
                    <input class="form-check-input" type="checkbox" id="send_building_test_notification_email" v-model="send_building_test_notification_email">
                    <label class="form-check-label" for="send_building_test_notification_email">
                        Send Building Test Notification Email
                    </label>
                </div>
            </div>

            <div class="form-group" v-bind:class="{'bg-danger': !send_building_device_main_loss_notification_email, 'text-light': !send_building_device_main_loss_notification_email}">
                <div class="form-check form-check-inline p-2">
                    <input class="form-check-input" type="checkbox" id="send_building_device_main_loss_notification_email" v-model="send_building_device_main_loss_notification_email">
                    <label class="form-check-label" for="send_building_device_main_loss_notification_email">
                        Send Building Main Loss Notification Email
                    </label>
                </div>
            </div>

            <div class="form-group" v-bind:class="{'bg-danger': !send_test_failed_email, 'text-light': !send_test_failed_email}">
                <div class="form-check form-check-inline p-2">
                    <input class="form-check-input" type="checkbox" id="send_test_failed_email" v-model="send_test_failed_email">
                    <label class="form-check-label" for="send_test_failed_email">
                        Send Test Failed Email
                    </label>
                </div>
            </div>

            <div class="form-group" v-bind:class="{'bg-danger': !send_test_failed_detail_csv_email, 'text-light': !send_test_failed_detail_csv_email}">
                <div class="form-check form-check-inline p-2">
                    <input class="form-check-input" type="checkbox" id="send_test_failed_detail_csv_email" v-model="send_test_failed_detail_csv_email">
                    <label class="form-check-label" for="send_test_failed_detail_csv_email">
                        Send Test Failed Detail CSV Email
                    </label>
                </div>
            </div>

            <div class="form-group" v-bind:class="{'bg-danger': !send_test_pass_email, 'text-light': !send_test_pass_email}">
                <div class="form-check form-check-inline p-2">
                    <input class="form-check-input" type="checkbox" id="send_test_pass_email" v-model="send_test_pass_email">
                    <label class="form-check-label" for="send_test_pass_email">
                        Send Test Passed Email
                    </label>
                </div>
            </div>

            <div class="form-group" v-bind:class="{'bg-danger': !send_certificate_email, 'text-light': !send_certificate_email}">
                <div class="form-check form-check-inline p-2">
                    <input class="form-check-input" type="checkbox" id="send_certificate_email" v-model="send_certificate_email">
                    <label class="form-check-label" for="send_certificate_email">
                        Send Certificate Email
                    </label>
                </div>
            </div>

            <button class="btn btn-primary" type="submit">Update</button>

            <transition name="fade">
                <div class="alert alert-success my-4" role="alert" v-if="response">
                    Settings updated!
                </div>
            </transition>

        </form>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        admin_porting_emails: '',
        send_certificate_email: true,
        send_test_failed_detail_csv_email: true,
        send_test_failed_email: true,
        send_test_failed_email_block_threshold: 10,
        send_test_pass_email: true,
        send_building_test_notification_email: true,
        send_building_device_main_loss_notification_email: true,
        data_org : {},
        options: [
          'admin_porting_emails',
          'send_certificate_email',
          'send_test_failed_detail_csv_email',
          'send_test_failed_email',
          'send_test_failed_email_block_threshold',
          'send_test_pass_email',
          'send_building_test_notification_email',
          'send_building_device_main_loss_notification_email',
        ],
        response: false
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      load () {
        let options = this.options;
        for (let i = 0; i < options.length; i++) {
          this
            .$store
            .dispatch(
              'apiResult',
              {
                method: 'GET',
                path: `api/options?name=${encodeURIComponent(options[i])}`,
                path_template: '/api/options',
              }
            ).then(response => {
              if (response.status === 200) {
                this[options[i]] = response.data.data.value;
                this.data_org[options[i]] = response.data.data.value;
              }
              return response;
            });
        }
      },
      update () {
        let options = this.options,
            top = this;
        for (let i = 0; i < options.length; i++) {
          if(this[options[i]] !== this.data_org[options[i]]) {
            this
              .$store
              .dispatch(
                'apiResult',
                {
                  method: 'PATCH',
                  path: `api/options`,
                  data: {
                    name: options[i],
                    value: this[options[i]]
                  },
                  path_template: '/api/options',
                }
              ).then(response => {
              if (response.status === 200) {
                this[options[i]] = response.data.data.value;
                this.data_org[options[i]] = response.data.data.value;
                this.response = true;
                setTimeout(function() { top.response = false; }, 1000);
              }
              return response;
            });
          }
        }
      }
    }
  }
</script>